import { MessageType } from './Message';
import { IMessageCallbacks, ThreadChannel } from './ThreadChannel';

export type WithPromiseFunctions<T> = {
  [K in keyof T]: T[K] extends (...args: infer Args) => infer Result
    ? (...args: Args) => Promise<WithPromiseFunctions<Result>>
    : T[K] extends Record<string, unknown>
      ? WithPromiseFunctions<T[K]>
      : T[K];
};

export class HostChannel extends ThreadChannel {
  #consumerAPIInstances: Record<string, any> = {};
  #consumerAPIInstancesResolvers: {
    type: string;
    cb: (instance: any) => void;
  }[] = [];

  protected messageEvents: IMessageCallbacks = {
    [MessageType.ExposeAPI]: (message) => {
      const pendingTypeInstances = this.#consumerAPIInstancesResolvers.filter(
        ({ type }) => type === message.payload.type,
      );

      this.#consumerAPIInstancesResolvers =
        this.#consumerAPIInstancesResolvers.filter(
          ({ type }) => type !== message.payload.type,
        );

      pendingTypeInstances.forEach(({ cb }) => {
        cb(message.payload);
      });
    },
  };

  public waitAPI<TInstance = any>(
    type: string,
  ): Promise<WithPromiseFunctions<TInstance>> {
    return new Promise((resolve) => {
      this.onAPICallback<TInstance>(type, (_workerApi) => {
        resolve(_workerApi);
      });
    });
  }

  public onAPICallback<TInstance = any>(
    type: string,
    cb: (instance: WithPromiseFunctions<TInstance>) => void,
  ) {
    if (this.#consumerAPIInstances[type]) {
      cb(this.#consumerAPIInstances[type]);
      return;
    }

    this.#consumerAPIInstancesResolvers.push({
      type,
      cb,
    });
  }
}
